// ** Store Imports
import { handleNavbarColor } from "@src/redux/layout";
import type { RootState } from "@src/redux/store";

import { useSelector } from "react-redux";
import { useAppDispatch } from "@src/redux/hooks";

export const useNavbarColor = () => {
  // ** Hooks
  const dispatch = useAppDispatch();
  const store = useSelector((state: RootState) => state.layout);

  // ** Return a wrapped version of useState's setter function
  const setNavbarColor = (value: any) => {
    dispatch(handleNavbarColor(value));
  };

  return { navbarColor: store.navbarColor, setNavbarColor };
};
